export default __webpack_public_path__ + "static/updated_data-8d258dafd6b7aef0a99e691ce829f6d3.mp4";